import { Timestamp } from "firebase/firestore";

/**
 * Converte diferentes formatos de data/timestamp para um objeto Date JavaScript
 * Trata tanto Timestamps válidos do Firestore quanto maps com seconds/nanoseconds
 * 
 * @param {*} dateValue - Valor que pode ser um Timestamp, map com seconds/nanoseconds, string ou Date
 * @returns {Date|null} - Objeto Date ou null se não foi possível converter
 */
export const convertToDate = (dateValue) => {
  if (!dateValue) return null;

  try {
    // Se já é um Date
    if (dateValue instanceof Date) {
      return dateValue;
    }

    // Se é uma string
    if (typeof dateValue === 'string') {
      return new Date(dateValue);
    }

    // Se é um Timestamp válido do Firestore com método .toDate()
    if (dateValue && typeof dateValue.toDate === 'function') {
      return dateValue.toDate();
    }

    // Se é um map com seconds e nanoseconds (formato incorreto salvo anteriormente)
    if (dateValue && typeof dateValue === 'object' && 
        dateValue.seconds !== undefined && dateValue.nanoseconds !== undefined) {
      return new Date(dateValue.seconds * 1000);
    }

    // Se é um map com _seconds e _nanoseconds (formato interno do SDK Firestore)
    if (dateValue && typeof dateValue === 'object' &&
        dateValue._seconds !== undefined && dateValue._nanoseconds !== undefined) {
      return new Date(dateValue._seconds * 1000);
    }

    // Se é um Timestamp do Firestore (mas sem método toDate)
    if (dateValue instanceof Timestamp) {
      return dateValue.toDate();
    }

    console.warn("Formato de data não reconhecido em convertToDate:", dateValue);
    return null;

  } catch (error) {
    console.error("Erro ao converter data em convertToDate:", error, dateValue);
    return null;
  }
};

/**
 * Converte um valor Date para Timestamp do Firestore, garantindo o formato correto
 * 
 * @param {Date|string} dateValue - Valor de data
 * @returns {Timestamp|null} - Timestamp do Firestore ou null se não foi possível converter
 */
export const convertToTimestamp = (dateValue) => {
  if (!dateValue) return null;

  try {
    let date;
    
    if (typeof dateValue === 'string') {
      date = new Date(dateValue);
    } else if (dateValue instanceof Date) {
      date = dateValue;
    } else {
      console.warn("Formato de entrada não suportado em convertToTimestamp:", dateValue);
      return null;
    }

    if (isNaN(date.getTime())) {
      console.warn("Data inválida em convertToTimestamp:", dateValue);
      return null;
    }

    return Timestamp.fromDate(date);

  } catch (error) {
    console.error("Erro ao converter para Timestamp em convertToTimestamp:", error, dateValue);
    return null;
  }
};

/**
 * Função para verificar se um valor é um formato de data válido
 * 
 * @param {*} dateValue - Valor a ser verificado
 * @returns {boolean} - true se é um formato de data válido
 */
export const isValidDateFormat = (dateValue) => {
  if (!dateValue) return false;

  // Date válido
  if (dateValue instanceof Date && !isNaN(dateValue.getTime())) {
    return true;
  }

  // String válida
  if (typeof dateValue === 'string' && !isNaN(new Date(dateValue).getTime())) {
    return true;
  }

  // Timestamp válido do Firestore
  if (dateValue && typeof dateValue.toDate === 'function') {
    return true;
  }

  // Map com seconds e nanoseconds
  if (dateValue && typeof dateValue === 'object' && 
      dateValue.seconds !== undefined && dateValue.nanoseconds !== undefined) {
    return true;
  }

  return false;
};
